export default __webpack_public_path__ + "static/media/homeBanner.ccba6e90.jpg";